export default {
	data() {
		return {
			fields: {},
			errors: {},
			success: false,
			warning: false,
			loaded: true,
			action: '',
			clearInputs: false,
		}
	},

	methods: {
		submit() {
			if (this.loaded) {
				this.loaded = false;
				this.success = false;
				this.warning = false;
				this.errors = {};
				axios.post(this.action, this.fields).then(response => {
					//Clear input fields.
					if(this.clearInputs) {
						this.fields = {};
					}

					this.loaded = true;
					this.success = true;
				}).catch(error => {
					this.loaded = true;
					if (error.response.status === 422) {
						this.errors = error.response.data.errors || {};
					} else if (error.response.status === 400) {
						console.log(error);
						this.warning = true;
					}
				});
			}
		},

	},
}